module.exports = __webpack_public_path__ + "img/fill_2.696ffeeb.svg";